module.exports = __webpack_public_path__ + "static/media/beccaSq.69fd2797.png";